import { object, string } from 'yup';

export const ADMIN_BASE_ROUTE = 'ADMIN_BASE_ROUTE';

export const errorMessage = 'Please enter a value.';

export const validationSchema = object().shape({
  name: string().required(errorMessage)
});

export const truncatorProps = { withToolTip: true, toolTipPosition: 'right', enableRecalc: true };

export const COLUMN_WIDTHS = {
  XXXS: 25,
  XXS: 50,
  XS: 65,
  SM: 85,
  MD: 100,
  LG: 150,
  XL: 250,
  XXL: 350
};
